import { chevronDown } from "@simplybusiness/icons";
import { Icon, Text } from "@simplybusiness/mobius";
import { OpeningHoursEntry } from "./OpeningHoursEntry";
import type { OpeningHoursProps } from "./types";

export const OpeningHours = (props: OpeningHoursProps) => {
  const { openingHours } = props;

  if (!openingHours) {
    console.warn("OpeningHours will not render. Prop openingHours is empty.");
    return null;
  }

  return (
    <details className="mobius-footer__opening-hours-container">
      <summary className="mobius-footer__opening-hours-toggle">
        <Text variant="small" elementType="span">
          See our opening hours
        </Text>
        <Icon
          className="mobius-footer__opening-hours-toggle-icon"
          icon={chevronDown}
          size="xs"
        />
      </summary>
      <ul className="mobius-footer__opening-hours-list">
        {openingHours.map(entry => {
          const { day, hours } = entry;

          return (
            <li key={day} className="mobius-footer__opening-hours-list-item">
              <OpeningHoursEntry day={day} hours={hours} />
            </li>
          );
        })}
      </ul>
    </details>
  );
};
